const state = {
    productCategory : null
}

const getters = {
    getProductCategory : state => {
        return state.productCategory
    }
}

const mutations = {
    productCategory (state, productCategory){
        if(productCategory){
            state.productCategory = productCategory;
        } else {
            state.productCategory = null;
        }
    }
}

const actions = {
    setProductCategory ({ commit }, productCategory){
        commit('productCategory', productCategory);
    }
}

export default{
    state,
    getters,
    mutations,
    actions
}